import { render, staticRenderFns } from "./GrantAuction.vue?vue&type=template&id=8e8fe17a&scoped=true&"
import script from "./GrantAuction.vue?vue&type=script&lang=ts&"
export * from "./GrantAuction.vue?vue&type=script&lang=ts&"
import style0 from "./GrantAuction.vue?vue&type=style&index=0&id=8e8fe17a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8fe17a",
  null
  
)

export default component.exports